'use es6';

import { Component } from 'react';
import ProgressBar from './ProgressBar';
import Score from './Score';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class PageScore extends Component {
  render() {
    const {
      score,
      overallScore
    } = this.props;
    const scorePercentage = score / overallScore * 100;
    return /*#__PURE__*/_jsxs(Score, {
      scorePercentage: scorePercentage,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "score",
        children: [/*#__PURE__*/_jsx("span", {
          children: score
        }), /*#__PURE__*/_jsxs("span", {
          className: "overall",
          children: ["/", overallScore]
        })]
      }), /*#__PURE__*/_jsx(ProgressBar, {
        scorePercentage: scorePercentage
      })]
    });
  }
}